/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import { TOKEN_REFRESH_URL } from '../constants/api.js';

const attunedApi = axios.create({
    baseURL: `${ process.env.API_URL }`,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

export const refreshAuthToken = () => attunedApi.post(TOKEN_REFRESH_URL, { })
    .then(token => {
        return token;
    })
    .catch(err => {
        throw err;
    });


const generateLoginUrl = (includeParams = true) => {
    const url = new URL(window.location);
    const lang = url.searchParams.get('lang');

    const loginQueryParams = new URLSearchParams({ next_url: encodeURI(window.location.href) });
    if (lang) loginQueryParams.append('lang', lang);

    if (includeParams) { return `${ process.env.LOGIN_URL }?${ loginQueryParams.toString() }`; }

    return process.env.LOGIN_URL;
};


// Instantiate the interceptor (you can chain it as it returns the axios instance)
attunedApi.interceptors.response.use((response) => {
    return response.data;
}, (err) => {
    const error = err.response;

    if (!error) return;

    if (error.status === 401 && error.config && !error.config.__isRetryRequest) {
        if (error.config.url === TOKEN_REFRESH_URL) {
            window.location.assign(generateLoginUrl());
            return;
        }
        return refreshAuthToken()
            .then(() => {
                error.config.__isRetryRequest = true;
                return attunedApi(error.config);
            })
            .catch((er) => {
                window.location.assign(generateLoginUrl());
                throw er;
            });
    }

    throw error.data;
});

export { attunedApi, generateLoginUrl };
